<template>
  <v-container fluid>
    <v-row class="mt-8">
      <v-col cols="12" md="8" offset-md="2" lg="6" offset-lg="3">
        <v-card outlined class="text-center pa-4">
          <v-avatar :size="240" color="transparent" class="ma-1">
            <v-img :src="logoUrl" :lazy-src="''">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>
          <v-card-title class="justify-center">Mailadresse muss verifiziert werden</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="mt-2" sm="10" offset-sm="1">
                Lieber Bundesbruder, <br>
                <br>
                deine E-Mailadresse <span class="font-weight-bold">{{ mail }}</span> wurde bisher nicht verifiziert. <br>
                Um auf Korpodesk zuzgreifen musst du deine E-Mailadresse
                bestätigen, in dem du auf den Verifizierungslink in der zugesendeten Mail klickst. Solltest
                du keine Mail bekommen haben, kannst du dir eine neue Mail zusenden lassen. Bitte schau auch in deinem Spam-Ordner nach.<br><br>
                <v-btn block class="primary" @click="sendVerifizierungsMail()">Mail erneut senden</v-btn>
                <v-btn block text class="mt-2" @click="reload()">Ich habe die Mailadresse bestätigt</v-btn>
                <v-divider class="my-2"></v-divider>
                Probleme bei der Anmeldung?
                <br>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" href="https://wa.me/491634445098" target="_blank"><v-icon>mdi-whatsapp</v-icon></v-btn>
                  </template>
                  <span>Whatsapp</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" href="mailto:breuerbe@gmail.com" target="_blank"><v-icon>mail</v-icon></v-btn>
                  </template>
                  <span>Mail</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        logoUrl: null
      }
    },
    mounted () {
      this.loadLogo()
    },
    computed: {
      mail () {
        if (this.$firebase.auth().currentUser) {
          return this.$firebase.auth().currentUser.email
        }
      },
      mailStatus () {
        if (this.$firebase.auth().currentUser) {
          if (this.$firebase.auth().currentUser.emailVerified) {
            this.$router.push('/')
            return this.$firebase.auth().currentUser.emailVerified
          }
        }
      }
    },
    watch: {
      mailStatus (value) {
        if (value) {
          this.$router.push('/')
        }
      },
      user (value) {
        if (value !== null && value !== undefined) {
          this.$router.push('/registrieren')
        }
      }
    },
    methods: {
      async loadLogo () {
        try {
          const url = await this.logoImage()
          console.log(url)
          this.logoUrl = url
        } catch (error) {
          console.error('Error loading logo:', error)
        }
      },
      async logoImage () {
        try {
          const storagePath = `/design/logo/${this.$vars.verbindung}`
          const url = await this.$firebase.storage().ref(storagePath).getDownloadURL()
          return url
        } catch (error) {
          console.error(error)
          throw error // Rethrow the error to be caught in the calling function
        }
      },
      sendVerifizierungsMail () {
        let user = this.$firebase.auth().currentUser
        if (!this.$firebase.auth().currentUser.emailVerified) {
          user.sendEmailVerification().then(function () {
            this.$store.state.snackbar = {
              show: true,
              nachricht: 'Dir wurde eine neue Mail zugesandt.'
            }
            console.log('Verification Mail send')
          }).catch(error => {
            console.log(error)
          })
        }
        return user
      },
      reload () {
        this.$router.push('/')
      }
    }
    // beforeMount () {
    //   this.sendVerifizierungsMail()
    // }
  }
</script>

<style scoped>
.container{
  padding-left: 16px;
}
</style>



// WEBPACK FOOTER //
// VerifiziereMail.vue?2dd8d242